// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    pickerColor: {
        id: 'picker.pickerColor',
        defaultMessage: 'colour'
    },
    pickerTuneable: {
        id: 'picker.tuneable',
        defaultMessage: 'tone'
    },
    pickerDimmer: {
        id: 'picker.dimmer',
        defaultMessage: 'dimmer'
    },
    pickerWhite: {
        id: 'picker.white',
        defaultMessage: 'white'
    }
});



// WEBPACK FOOTER //
// ./src/core/i18n/components/bulbs/intl.js